import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { Form, CheckBox } from 'fw/forms';
import { Box } from 'fw/components';
import * as Modals from 'fw/globals/Modals'

class CheckBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: true
			}
		};
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="CheckBox">
				<Form
					values={this.state.form}
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}>
					<Row>
						<Col md={4}>
							<CheckBox name="default" label="Default" />
						</Col>
						<Col md={4}>
							<CheckBox name="preset" label="Preset" />
						</Col>
						<Col md={4}>
							<CheckBox name="disabled" label="Disabled" disabled={true} />
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default CheckBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/CheckBoxDemo.js